/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".disable[_ngcontent-%COMP%]{pointer-events:none;cursor:default;color:#789;background-color:#ff7737}\n/*# sourceMappingURL=enroll-edocs.component.css.map*/"];
export { styles as styles };
